import styled from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';
import * as React from 'react';
const { colors, devices, fontSizes, spaces } = theme;

const StyledTrademarkGeniusMonitoringSection = styled.div`
  padding-top: 100px;
  padding-bottom: 100px;
  background: #fafaff;
  @media ${devices.tablet} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;
const StyledContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media ${devices.tablet} {
    flex-direction: column;
    gap: 10px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const StyledLeftPart = styled.div`
  display: flex;
  flex-direction: column;
  color: #7b848d;
  font-size: 14px;
  font-family: 'MontserratRegular';
  line-height: 26px;
`;
const StyledLeftContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  p {
    color: #7b848d;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.small}px;
    line-height: 20px;
    text-align: left;
  }
  img {
    min-width: 200px;
  }
  @media ${devices.tablet} {
    flex-direction: column;
  }
`;
const StyledSeparator = styled.div`
  background: #dee0e8;
  width: 1px;
`;
const StyledHeaderBlue = styled.div`
  color: #f37217;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: ${fontSizes.large4X}px;
  width: 100%;
  margin-bottom: 0.5rem;
  line-height: 30px;
  @media ${devices.tablet} {
    margin-bottom: 0px;
    font-size: ${fontSizes.largeX}px;
  }
`;
const TrademarkGeniusMonitoringSection = () => {
  return (
    <StyledTrademarkGeniusMonitoringSection>
      <StyledContainer>
        <StyledLeftContainerColumn>
          <img
            src={`${config.basePath}/alive-frame2.png`}
            alt=""
            layout="fill"
          />
          <StyledLeftPart>
            <StyledHeaderBlue>
              Trademark Genius's Unique Approach
            </StyledHeaderBlue>{' '}
            What sets Trademark Genius apart is our dedication to our clients.
            We understand that every brand is unique, and our approach reflects
            this understanding. We tailor our services to meet your specific
            needs and objectives.
          </StyledLeftPart>
        </StyledLeftContainerColumn>
        <StyledSeparator />
        <StyledLeftContainerColumn>
          <img
            src={`${config.basePath}/alive-frame3.png`}
            alt=""
            layout="fill"
          />
          <StyledLeftPart>
            <StyledHeaderBlue>
              Understanding Trademark Monitoring
            </StyledHeaderBlue>{' '}
            In a world where brand identity is everything, protecting it is not
            an option but a necessity. Trademark Genius is your trusted partner
            in ensuring the longevity and exclusivity of your brand. Don't leave
            your brand's future to chance; take proactive steps to safeguard it
            today.
          </StyledLeftPart>
        </StyledLeftContainerColumn>
      </StyledContainer>
    </StyledTrademarkGeniusMonitoringSection>
  );
};

export default TrademarkGeniusMonitoringSection;
